import { render, staticRenderFns } from "./ArtEnrollment.vue?vue&type=template&id=520c5a02&scoped=true"
import script from "./ArtEnrollment.vue?vue&type=script&lang=js"
export * from "./ArtEnrollment.vue?vue&type=script&lang=js"
import style0 from "./ArtEnrollment.vue?vue&type=style&index=0&id=520c5a02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520c5a02",
  null
  
)

export default component.exports